module.exports = __webpack_public_path__ + "static/media/bd3.d9a9b8dc.jpg";